<div class="login d-flex justify-content-center align-items-center">
    <div class="d-flex flex-column align-items-center pb-4">
        <img src="../img/main-logo.png" [class.invalid]="invalidLogin" alt="Logo" width="220" />
        <form (submit)="login()" >
            <div class="login__inner mt-3 mb-5 p-4">
                <p class="login__title">Login</p>
                <div class="form-field mb-3">
                    <label class="login__label" for="email">Username</label>
                    <input type="email" id="email" name="userEmail" [(ngModel)]="userEmail" class="form-control" />
                </div>
                <div class="form-field mb-3">
                    <label class="login__label" for="password">Password</label>
                    <input type="password" id="password" name="userPass" [(ngModel)]="userPass" class="form-control" />
                </div>
                <div class="d-flex justify-content-between">
                    <button type="button" class="btn btn-link btn-sm" (click)="forgot()">Forgot Password?</button>
                    <button type="submit" class="btn btn-primary btn-sm text-uppercase px-4" [class.loading]="loader" [disabled]="!(userEmail && userPass)">Login</button>
                </div>
            </div>    
        </form>
    </div>
</div>